import ResponsiveContainer from '../../common/ResponsiveContainer';
import './Login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPeace, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import T4Button from '../../common/T4Button';
import { login as loginApi } from '../../api';
import useUserStore from '../../hooks/useUserStore';

const Login = () => {
  const screenHeigth = window.innerHeight;
  const navbarHeight = 80;
  const login = useUserStore((state) => state.login);
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoginError(null);
    loginApi(data)
      .then((res) => {
        // api.js unwraps the envelope, so res.data = { token, user }
        login(res.data.user, res.data.token);
        navigate('/');
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status === 403) {
          navigate('/crear-cuenta', { state: { pendingVerificationEmail: data.email } });
          return;
        }
        setLoginError(err.response?.data?.message || 'Error al iniciar sesión');
      });
  };

  return (
    <div className='flex font-montserrat font-semibold w-full' style={{ height: `${screenHeigth - navbarHeight}px` }}>
      <div className='hidden md:flex md:max-w-[25%] lg:max-w-[50%] w-full login-image shadow-inner' />
      <div className='flex justify-center max-w-full md:max-w-[75%] lg:max-w-[50%] w-full mx-5'>
        <div className='bg-white shadow-xl w-full my-auto p-4 px-10 max-w-[500px] xl:max-w-[600px]'>
          <img src='/logo.png' alt='' width='100px' className='mx-auto' />
          <p className='text-center my-5 text-xl text-red-1'>
            Bienvenido a Turkish4Love <FontAwesomeIcon icon={faHandPeace} />
          </p>

          <h1 className='text-center text-2xl'>Ingresa a tu cuenta</h1>
          <form className='flex flex-col' onSubmit={handleSubmit(onSubmit)}>
            {/* include validation with required or other standard HTML validation rules */}
            <label htmlFor='email' className='text-red-1 mt-5'>
              Correo electrónico
            </label>
            <input
              className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 text-gray-600'
              type='email'
              {...register('email', { required: true })}
            />
            {/* errors will return when field validation fails  */}
            {errors.email && <span>Este campo es requerido</span>}

            <label htmlFor='password' className='text-red-1 mt-5'>
              Contraseña
            </label>
            <div className='relative'>
              <input
                className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 pr-10 text-gray-600'
                type={showPassword ? 'text' : 'password'}
                {...register('password', { required: true, minLength: 6 })}
              />
              <button
                type='button'
                onClick={() => setShowPassword((prev) => !prev)}
                className='absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-1 transition-colors'
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
            {/* errors will return when field validation fails  */}
            {errors.password && <span>Este campo es requerido</span>}

            <Link to='/reset-password' className='mt-2 text-sm text-red-1 hover:underline self-end'>
              ¿Olvidaste tu contraseña?
            </Link>

            {loginError && (
              <p className='mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2 text-center'>
                {loginError}
              </p>
            )}
            <T4Button>Iniciar sesión</T4Button>
            <hr />
            <T4Button link to='/crear-cuenta'>
              ¡No tengo cuenta!
            </T4Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
